"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Redo = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Redo = function Redo() {
  return react_1.default.createElement("path", {
    d: "M11.48 7.99997C14.0513 7.95906 16.546 8.87499 18.48 10.57L20.9 8.14997C20.9818 8.06411 21.0919 8.01082 21.21 7.99997H21.5C21.7761 7.99997 22 8.22383 22 8.49997V15.5C22 15.7761 21.7761 16 21.5 16H14.5C14.2239 16 14 15.7761 14 15.5V15.21C13.998 15.0744 14.0523 14.944 14.15 14.85L16.67 12.33C15.2152 11.1176 13.3734 10.4682 11.48 10.5C7.81 10.5 4.79 12.73 4.48 15.55C4.45947 15.8011 4.25189 15.9957 4 16H2.5C2.36016 16.0004 2.22653 15.9423 2.13152 15.8397C2.03651 15.7371 1.98881 15.5994 2 15.46C2.33 11.29 6.45 7.99997 11.48 7.99997Z",
    fill: "currentColor"
  });
};

exports.Redo = Redo;